<template>
  <div class="th-card review-container">
    <div class="image mr-4">
      <img v-if="review.profilePictureSmall || review.profilePicture" :src="backendUrl + review.profilePictureSmall" width="50" class="rounded-full" :alt="review.firstName">
      <avatar v-else :size="50" :username="review.firstName + ' ' +  review.lastName || 'Nurul Jannah'"></avatar>
    </div>
    <div class="content">
      <div class="header-review mb-3">
        <div>
          <star-rating
            :rating="review.rating"
            :star-size="18"
            :show-rating="false"
            :rounded-corners="true"
            read-only
          />
          <p class="th-text-primary th-font-weight-bold">{{review.firstName}} {{review.lastName}}</p>
        </div>
        <div>
          <p class="th-font-gray-3">{{moment(review.postedAt).locale('id').fromNow()}}</p>
        </div>
      </div>
      <div v-html="review.description" class="th-text-paragraph"></div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import StarRating from 'vue-star-rating'
import Avatar from 'vue-avatar'
export default {
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
  components: {
    StarRating,
    Avatar,
  },
  data() {
    return {
      backendUrl: process.env.VUE_APP_BACKEND_URL,
    }
  },
  methods: {
    moment,
  },
}
</script>

<style lang="scss">
.review-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-top: 20px;
  padding: 16px;

  @media (min-width: 768px) {
    & {
      flex-direction: row;
      justify-content: center;
    }
  }

  .image {
    // width: 10%;
  }

  .content {
    width: 90%;
    .header-review {
      margin-top: 14px;
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
      align-items: flex-start;

      @media (min-width: 768px) {
        & {
          margin-top: 0;
          flex-direction: row;
          justify-content: space-between;
        }
      }

      .vue-star-rating {
        margin-left: -2px;
        margin-bottom: 4px;
      }
    }
  }
}
</style>
